export default __webpack_public_path__ + "static/Fira-Code-Regular-54a82d62ed3c2e9a13891709630f3240.woff2";